import type { enTainan } from './en.tainan';

export const esTainan: typeof enTainan = {
  tainan: {
    mapNames: { tainan: 'Tainan' },
    zones: {
      tn_city: 'Casco antiguo de Tainan',
      tn_station: 'Estación de alta velocidad',
      tn_chihkan: 'Torre Chihkan',
      tn_shennong: 'Calle Shennong',
      tn_anping: 'Anping',
      tn_market: 'Mercado de la calle Guohua',
      tn_confucius: 'Templo de Confucio',
      tn_canal: 'Canal de Anping',
    },
    objects: {
      tn_hsr: 'Estación de alta velocidad · Tainan',
      tn_shuttle: 'Parada de la lanzadera (H31)',
      tn_chihkan: 'Torre Chihkan',
      tn_turtles: 'Tortugas de piedra',
      tn_lanterns: 'Taller de faroles',
      tn_zeelandia: 'Fuerte Zeelandia',
      tn_treehouse: 'Árbol-casa de Anping',
      tn_shrimp: 'Puesto de galletas de gamba',
      tn_candied: 'Tienda de fruta confitada',
      tn_boatRide: 'Paseo en barca por el canal',
      tn_beefSoup: 'Puesto de sopa de ternera',
      tn_danzai: 'Puesto de fideos danzai',
      tn_coffin: 'Puesto de pan-ataúd',
      tn_confucius: 'Sala del Templo de Confucio',
    },
    npc: {
      tn_soupGranny: 'Abuela de la sopa de ternera',
      tn_fortGuide: 'Guía del fuerte',
      tn_scholar: 'Estudiante confuciano',
      tn_crackerLady: 'Vendedora de galletas de gamba',
      tn_candiedAunt: 'Tía de la fruta confitada',
      tn_fisher: 'Pescador del canal',
      tn_kid1: 'Niño con cometa',
      tn_kid2: 'Niña con cuaderno',
      tn_lanternArtist: 'Artista de faroles',
      tn_shuttleDriver: 'Conductor de la lanzadera',
      tn_cyclist: 'Ciclista',
      tn_grandpa: 'Abuelo del ajedrez',
      tn_boatman: 'Barquero',
    },
    items: {},

    shuttle: {
      text: 'La estación de alta velocidad de Tainan está en Guiren, a 10 km del casco antiguo. La lanzadera gratuita H31 va al centro cada 20 minutos: media hora de viaje.',
      ask: '🚌 Pregunta al conductor (inglés)',
      q: '¿Cómo preguntas si este bus va al centro?',
      // English practice
      a: ['Excuse me, does this bus go to the city centre?', 'Bus! City! Now!', 'You drive me downtown.'],
      right: '«Yes! Chihkan Tower is the fourth stop. Hold on tight!»',
      wrong: 'El conductor levanta una ceja. Prueba una pregunta más educada: empieza por «Excuse me…».',
    },
    chihkan: {
      text: 'La Torre Chihkan (赤崁樓) se alza sobre el fuerte Provintia, construido por los holandeses en 1653. La dinastía Qing añadió después estos dos pabellones: el templo del Dios del Mar y el pabellón Wenchang de los estudiantes.',
      learn: '🏯 ¿Quién construyó el fuerte? (inglés)',
      q: 'Who built the first fort here?',
      // English practice
      a: ['The Dutch, in 1653.', 'The Romans, in 100.', 'The Japanese, in 1950.'],
      right: '¡Eso es! Los holandeses gobernaron Tainan 38 años, hasta que Koxinga (鄭成功) los expulsó en 1662.',
      wrong: 'Mira la base de ladrillo: tiene 370 años…',
    },
    turtles: {
      text: 'Nueve tortugas de piedra (贔屭) cargan altas estelas en el lomo: un regalo del emperador Qianlong en 1788. Cuenta la leyenda que una cayó al puerto y hubo que sustituirla.',
      count: '🐢 Cuenta las tortugas (inglés)',
      q: 'How many turtles were there at first?',
      // English practice: number words
      a: ['Nine.', 'Seven.', 'Twelve.'],
      right: '¡Nueve! Una tortuga con una estela en el lomo significa larga vida y buenas noticias.',
      wrong: 'Cuenta otra vez, con los dedos, en inglés…',
    },
    confucius: {
      text: 'El Templo de Confucio (孔廟) se fundó en 1665: el primero de Taiwán. Sobre la puerta cuelga la placa 全臺首學, «la primera escuela de todo Taiwán». Los estudiantes aún vienen antes de los exámenes.',
      learn: '📜 Lee la placa (inglés)',
      q: 'What does 全臺首學 mean?',
      // English practice
      a: ['The first school of all Taiwan.', 'The biggest market of Taiwan.', 'No running in the temple.'],
      right: '¡Sí! «First» (首) y «school» (學). Haces una reverencia al maestro, como los estudiantes.',
      wrong: 'Pista: esto era una escuela, no un mercado…',
    },
    zeelandia: {
      text: 'El fuerte Zeelandia (安平古堡) fue el cuartel general holandés en Taiwán, construido en 1624. En 1662 Koxinga lo asedió nueve meses y los holandeses se marcharon. Solo quedan originales algunos muros de ladrillo rojo; la torre blanca es de 1930.',
      learn: '🏰 ¿Qué país? (inglés)',
      q: 'Which country built Fort Zeelandia?',
      // English practice
      a: ['The Netherlands.', 'Spain.', 'Australia.'],
      right: '¡Correcto, los holandeses! Sus ladrillos vinieron desde Java como lastre de los barcos.',
      wrong: 'La bandera de la torre tiene franjas rojas, blancas y azules…',
    },
    treehouse: {
      text: 'El Árbol-casa de Anping (安平樹屋) fue un almacén de la firma británica Tait & Co. Cuando lo abandonaron, un banyan creció sobre los muros, por las ventanas y por el techo: ahora el árbol ES la casa.',
      learn: '🌳 Descríbelo (inglés)',
      q: 'What happened to the warehouse?',
      // English practice: past tense
      a: ['A tree grew over it.', 'A tree will grow over it.', 'A tree is eating my lunch.'],
      right: '«Grew», el pasado de «grow». ¡Las raíces parecen cortinas de cuerda!',
      wrong: 'Pasó hace mucho tiempo. ¿Qué respuesta está en pasado?',
    },
    lanterns: {
      text: 'La farolera de la calle Shennong pinta faroles de papel a mano: rojos para la suerte, amarillos para la riqueza, y uno con un dragón para el Festival de los Faroles.',
      paint: '🏮 Elige un color (inglés)',
      q: 'The artist holds up a lantern the colour of a ripe tomato. What colour is it?',
      // English practice: colours
      a: ['Red.', 'Blue.', 'Green.'],
      right: '¡Red! Escribe 福 (buena fortuna) en él y lo cuelga sobre la calle para ti.',
      wrong: 'Mira los tomates de la mesa para la pista…',
      closed: 'La persiana está bajada; la farolera empieza a trabajar a partir de las tres de la tarde.',
    },
    boat: {
      text: 'Una barca turística se desliza por el canal de Anping, bajo los puentes y hacia el puerto viejo. El patrón cuenta historias de los barcos de sal que usaban estas aguas hace cien años.',
      ride: '🚤 Compra un billete (inglés)',
      price: 50,
      poor: 'El billete de la barca cuesta 50 monedas. ¡Vuelve con más dinero!',
      q: 'How do you ask for a ticket?',
      // English practice
      a: ['One ticket for the boat tour, please.', 'Boat. Me. Go.', 'Give ticket boat now.'],
      right: 'Treinta minutos en el agua: garcetas en la orilla, la torre del fuerte a lo lejos, una brisa fresca. ¡Precioso!',
      wrong: 'El barquero sonríe con paciencia. Prueba con «…please».',
      closed: 'La última barca ya ha salido por hoy. Los paseos van de nueve a seis.',
    },
    beefSoup: {
      vendor: 'Fresh beef soup! The beef is sliced thin and cooked in the hot broth right in your bowl. One bowl?',
      ok: 'One bowl of beef soup with rice, please.',
      bad: ['Beef. Bowl. Hurry.', 'I want beef soup, but no beef and no soup.'],
      done: 'La ternera está rosada y tierna, el caldo dulce con jengibre. La abuela añade una cucharada de arroz gratis. «¡Come despacio!»',
      price: 45,
    },
    danzai: {
      vendor: 'Danzai noodles — the Tainan way since 1895! A small bowl with a shrimp on top. Would you like one?',
      ok: 'Yes, please. One bowl of danzai noodles.',
      bad: ['Noodle give.', 'I eat all noodles, you pay.'],
      done: 'Un bol pequeño: fideos, carne picada, una gamba entera y una gota de vinagre negro. Pequeño, pero perfecto.',
      price: 40,
    },
    coffin: {
      vendor: 'Coffin bread! Don’t worry — it’s just a box of fried toast filled with creamy chicken stew. Hungry?',
      ok: 'Could I have one coffin bread, please?',
      bad: ['Coffin! Scary!', 'Toast box me want.'],
      done: 'Crujiente por fuera, cremoso por dentro. El nombre viene de la forma: una caja de pan con tapa. ¡Ñam!',
      price: 35,
    },
    shrimp: {
      vendor: 'Anping shrimp crackers, fried this morning! Light as air. Original or spicy?',
      ok: 'One bag of the original crackers, please.',
      bad: ['Crackers. All. Mine.', 'Spicy no original yes give.'],
      done: 'Una bolsa enorme y rosada, crujiente y dulce-salada. La vendedora mete una de más «para el camino».',
      price: 30,
    },
    candied: {
      vendor: 'Candied fruit from Anping: plums, mango, olives, tomatoes with ginger… Try a sample?',
      ok: 'Could I try the candied mango, please?',
      bad: ['Candy sample free all.', 'Me eat jar.'],
      done: 'Dulce, ácido y un poco salado. La tía envuelve una bolsita de mango y unas ciruelas para el tren.',
      price: 35,
    },
    closedMorning: '¡La olla está vacía! La sopa de ternera es un desayuno: ven antes de las dos de la tarde.',

    talk: {
      tn_soupGranny: [
        'Llevo cuarenta años vendiendo sopa de ternera aquí. La carne viene de Shanhua, fresca cada amanecer.',
        'English practice: “Would you like rice with that?” — “Yes, please!”',
        'En Tainan comemos dulce. ¡Hasta la sopa es un poco dulce!',
      ],
      tn_fortGuide: [
        'Estos ladrillos rojos vinieron de Java como lastre de los barcos holandeses. ¡Cuatrocientos años!',
        'English practice: “Where are you from?” — “I’m from Taiwan.”',
        'Desde la torre se ve el mar: en 1624 el agua llegaba hasta este muro.',
      ],
      tn_scholar: [
        'Los estudiantes dejan la entrada del examen en el altar para tener suerte. Yo dejé la mía la semana pasada.',
        'English practice: “Good luck on your exam!” — “Thank you!”',
        'Confucio decía: aprender sin pensar es inútil; pensar sin aprender es peligroso.',
      ],
      tn_crackerLady: [
        'Las galletas de gamba se hacen con gamba de verdad y tapioca. ¡Mira cómo se hinchan en el aceite!',
        'English practice: “How much is one bag?” — “Thirty dollars.”',
      ],
      tn_candiedAunt: [
        'Primero secamos la fruta al sol y luego la bañamos en azúcar y sal. ¡Tres semanas para una buena ciruela!',
        'English practice: “Can I try one?” — “Of course, here you are.”',
      ],
      tn_fisher: [
        'El canal se excavó en 1926 para llevar pescado y sal a la ciudad. ¡Ahora lleva turistas!',
        'English practice: “Did you catch anything?” — “Not yet… the fish are sleeping.”',
        'Fíjate en las garcetas. Ellas saben dónde están los peces.',
      ],
      tn_kid1: [
        '¡Mi cometa es una golondrina! El viento del canal es el mejor de Tainan.',
        'English practice: “Look! It’s flying!” — “Wow!”',
      ],
      tn_kid2: [
        'Estoy dibujando las tortugas. Nueve tortugas: una, dos, tres… la cuarta tiene la nariz rota.',
        'English practice: “What are you drawing?” — “I’m drawing a turtle.”',
      ],
      tn_lanternArtist: [
        'Todos los faroles de esta calle están pintados a mano. El del dragón me llevó tres días.',
        'English practice: “What colour do you like?” — “I like red.”',
        'De noche la calle Shennong se vuelve dorada. ¡Quédate hasta que se enciendan los faroles!',
      ],
      tn_shuttleDriver: [
        'H31 al centro, gratis con tu billete de alta velocidad. El próximo sale en diez minutos.',
        'English practice: “Does this bus stop at Chihkan Tower?” — “Yes, the fourth stop.”',
      ],
      tn_cyclist: [
        'Tainan es llana, perfecta para la bici. El camino del canal llega hasta el mar.',
        'English practice: “Turn left at the bridge.”',
      ],
      tn_grandpa: [
        'Ajedrez chino. El general no puede salir de su palacio… ¡como yo, que nunca salgo de Tainan!',
        'English practice: “Your move.” — “Hmm… let me think.”',
        'Cuando era niño, por el canal aún pasaban veleros cargados de sal.',
      ],
      tn_boatman: [
        'El paseo pasa bajo cinco puentes. ¡Agacha la cabeza en el tercero!',
        'English practice: “Please sit down and hold the rail.”',
      ],
    },
  },
};
